/** @typedef {import("../../types").StateVisualizacao} StateVisualizacao */
/** @typedef {import("../../types").OcorrenciaSelecionada} OcorrenciaSelecionada */

/**
 * Getters do módulo relatoOcorrencia/visualizacao.
 * Expõe a ocorrência selecionada para consumo nos componentes.
 */
export default {
  /**
   * Retorna a ocorrência selecionada no grid (ou null se nenhuma).
   * @param {StateVisualizacao} state
   * @returns {OcorrenciaSelecionada|null}
   */
  ocorrenciaSelecionada: state => state.ocorrenciaSelecionada
};